import { mainRouter } from '@/router/router'

const app = {
  state: {
    menuLists: [],
    openedSubmenuArr: [],
    currentPath: [{
      path: '/',
      name: 'home_index',
      title: '首页'
    }]
  },

  mutations: {
    /**
     * 左侧菜单栏根据路由配置显示对应的菜单
     * @param state
     */
    updateMenuLists(state) {
      let menuLists = [];
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      if (userInfo) {
        // const devList = []
        // userInfo.permissions = userInfo.permissions.concat(devList)
        mainRouter.forEach((routerItem) => {
          let menuItem = {
            children: [],
            name: '',
            icon: '',
            path: '',
            show: true
          };
          if (routerItem.hasOwnProperty('children')) {
            routerItem.children.forEach((routerChildItem) => {
              let allowRouter = [];
              const permission = userInfo.permissions
              const permissionName = routerChildItem.meta.access_name
              let flag = false
              if (permissionName && permissionName.includes('|')) {
                flag = permissionName.split('|').some(item => permission.includes(item))
              } else {
                flag = !permissionName || permission.includes(permissionName)
              }
              if (flag) {
                routerChildItem.children.forEach((permissionRouterItem) => {
                  userInfo.permissions.forEach((permissionItem) => {
                    const access_name = permissionRouterItem.meta.access_name || '';
                    if (!!~access_name.indexOf('|')) {
                      let access_name_array = access_name.split('|');
                      for (let i = 0; i < access_name_array.length; i++) {
                        if (access_name_array[i] === permissionItem) {
                          allowRouter.push(permissionRouterItem);
                          break;
                        }
                      }
                    } else {
                      if (permissionRouterItem.meta.access_name === permissionItem) {
                        allowRouter.push(permissionRouterItem);
                      }
                    }
                  });
                });
                if (allowRouter.length > 0) {
                  routerItem.hasOwnProperty('name') ? menuItem.name = routerItem.name : '';
                  routerItem.hasOwnProperty('path') ? menuItem.path = routerItem.path : '';
                  routerItem.meta.hasOwnProperty('icon') ? menuItem.icon = routerItem.meta.icon : '';
                  routerItem.meta.hasOwnProperty('title') ? menuItem.title = routerItem.meta.title : '';
                  routerItem.meta.hasOwnProperty('showToSidebar') ? menuItem.show = routerItem.meta.showToSidebar : '';

                  let pathShowToSidebar = routerChildItem.meta.hasOwnProperty('showToSidebar') ?
                    routerChildItem.meta.showToSidebar : true
                  if (pathShowToSidebar) {
                    menuItem.children.push({
                      title: routerChildItem.meta.title,
                      icon: routerChildItem.meta.icon,
                      name: routerChildItem.name,
                      path: routerItem.path + '/' + routerChildItem.path,
                      children: routerChildItem.children,
                      show: pathShowToSidebar
                    });
                  }
                }
              }
            });
          }
          menuItem.children.length > 0 ? menuLists.push(menuItem) : '';
        });
        state.menuLists = menuLists;
      }
    },

    /**
     * 设置当前所在的路径
     * @param state
     * @param data
     */
    setCurrentPath(state, data) {
      state.openedSubmenuArr = [];

      state.currentPath = [{
        path: '/',
        name: 'home_index',
        title: '首页'
      }];

      state.menuLists.forEach((menuItem) => {
        menuItem.children.forEach((subMenuItem) => {
          if (subMenuItem.name === data.routerInfo.name) {
            state.openedSubmenuArr.push(menuItem.name);

            let menuItemObj = {
              title: menuItem.title
            };

            let subMenuItemObj = {
              title: subMenuItem.title
            };

            state.currentPath.push(menuItemObj);

            state.currentPath.push(subMenuItemObj);

            if (subMenuItem.hasOwnProperty('children')) {
              subMenuItem.children.forEach((operateMenuItem) => {
                if (operateMenuItem.meta.title === data.routerInfo.meta.title && operateMenuItem.meta.title !== subMenuItem.title) {
                  let operateMenuitemObj = {
                    title: operateMenuItem.meta.title
                  };
                  state.currentPath[state.currentPath.length - 1].path = subMenuItem.path;
                  state.currentPath.push(operateMenuitemObj);
                  new Error('Find!!');
                }
              });
            }
          }
        });
      });
    }
  }
};

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js